export const getContentSmall = (leplus) => {
  if (leplus.content) {
    // remove html tag
    const withoutHtml = leplus.content.replace(/<[^>]*>/gm, "")
    // keep only 100 characters without cutting word
    return withoutHtml.replace(/^(.{150}[^\s]*).*/, "$1")+"..."
  }
  return "";
}